module.exports = __webpack_public_path__ + "static/img/new_thumb2.0b5b8ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_thumb2.jpg
// module id = YxFu
// module chunks = 0